import { PMTaskTemplate } from '../../models/types';

export const PM_CATEGORIES = [
  'HVAC',
  'Electrical',
  'Plumbing',
  'Fire & Life Safety',
  'Building Envelope',
  'Controls / BAS',
];

export const PM_TASK_LIBRARY: PMTaskTemplate[] = [
  // ─── HVAC ────────────────────────────────────────────────────────────────
  {
    id: 'hvac-001', category: 'HVAC', assetType: 'Air Handling Unit', taskName: 'Air Filter Replacement',
    trade: 'HVAC Tech', frequencyValue: 1, frequencyUnit: 'months',
    estimatedHours: 1, complianceRequired: false,
  },
  {
    id: 'hvac-002', category: 'HVAC', assetType: 'Air Handling Unit', taskName: 'Evaporator Coil Cleaning',
    trade: 'HVAC Tech', frequencyValue: 1, frequencyUnit: 'years',
    estimatedHours: 4, complianceRequired: false,
  },
  {
    id: 'hvac-003', category: 'HVAC', assetType: 'Air Handling Unit', taskName: 'Belt Inspection & Replacement',
    trade: 'HVAC Tech', frequencyValue: 3, frequencyUnit: 'months',
    estimatedHours: 1, complianceRequired: false,
  },
  {
    id: 'hvac-004', category: 'HVAC', assetType: 'Air Handling Unit', taskName: 'AHU Full Inspection (Drain Pan, Dampers, Actuators)',
    trade: 'HVAC Tech', frequencyValue: 6, frequencyUnit: 'months',
    estimatedHours: 3, complianceRequired: false,
  },
  {
    id: 'hvac-005', category: 'HVAC', assetType: 'Air Handling Unit', taskName: 'Motor & Bearing Lubrication',
    trade: 'HVAC Tech', frequencyValue: 6, frequencyUnit: 'months',
    estimatedHours: 1, complianceRequired: false,
  },
  {
    id: 'hvac-006', category: 'HVAC', assetType: 'Boiler', taskName: 'Annual Boiler Service & Flue Inspection',
    trade: 'Boiler Tech', frequencyValue: 1, frequencyUnit: 'years',
    estimatedHours: 4, complianceRequired: true, complianceStandard: 'ASME / Local Boiler Code',
  },
  {
    id: 'hvac-007', category: 'HVAC', assetType: 'Boiler', taskName: 'Boiler Water Treatment Check',
    trade: 'HVAC Tech', frequencyValue: 1, frequencyUnit: 'months',
    estimatedHours: 1, complianceRequired: false,
  },
  {
    id: 'hvac-008', category: 'HVAC', assetType: 'Cooling Tower', taskName: 'Cooling Tower Cleaning & Disinfection',
    trade: 'HVAC Tech', frequencyValue: 6, frequencyUnit: 'months',
    estimatedHours: 6, complianceRequired: true, complianceStandard: 'ASHRAE 188 (Legionella)',
  },
  {
    id: 'hvac-009', category: 'HVAC', assetType: 'Chiller', taskName: 'Chiller Tube Cleaning',
    trade: 'HVAC Tech', frequencyValue: 1, frequencyUnit: 'years',
    estimatedHours: 8, complianceRequired: false,
  },
  {
    id: 'hvac-010', category: 'HVAC', assetType: 'Chiller', taskName: 'Chiller Oil Analysis',
    trade: 'HVAC Tech', frequencyValue: 1, frequencyUnit: 'years',
    estimatedHours: 2, complianceRequired: false,
  },
  {
    id: 'hvac-011', category: 'HVAC', assetType: 'VAV Box', taskName: 'VAV Box Inspection & Calibration',
    trade: 'Controls Tech', frequencyValue: 1, frequencyUnit: 'years',
    estimatedHours: 2, complianceRequired: false,
  },
  {
    id: 'hvac-012', category: 'HVAC', assetType: 'Condenser', taskName: 'Condenser Coil Cleaning',
    trade: 'HVAC Tech', frequencyValue: 1, frequencyUnit: 'years',
    estimatedHours: 3, complianceRequired: false,
  },
  {
    id: 'hvac-013', category: 'HVAC', assetType: 'Split System / RTU', taskName: 'Refrigerant Level & Leak Check',
    trade: 'HVAC Tech', frequencyValue: 1, frequencyUnit: 'years',
    estimatedHours: 2, complianceRequired: false,
  },
  {
    id: 'hvac-014', category: 'HVAC', assetType: 'Thermostat / Controls', taskName: 'Thermostat & Controls Calibration',
    trade: 'Controls Tech', frequencyValue: 1, frequencyUnit: 'years',
    estimatedHours: 2, complianceRequired: false,
  },
  {
    id: 'hvac-015', category: 'HVAC', assetType: 'Exhaust Fan', taskName: 'Exhaust Fan Inspection',
    trade: 'HVAC Tech', frequencyValue: 6, frequencyUnit: 'months',
    estimatedHours: 1, complianceRequired: false,
  },

  // ─── Electrical ──────────────────────────────────────────────────────────
  {
    id: 'elec-001', category: 'Electrical', assetType: 'Electrical Panel', taskName: 'Electrical Panel Visual Inspection',
    trade: 'Electrician', frequencyValue: 1, frequencyUnit: 'years',
    estimatedHours: 2, complianceRequired: false,
  },
  {
    id: 'elec-002', category: 'Electrical', assetType: 'Electrical Panel', taskName: 'Thermographic (IR) Scan',
    trade: 'Electrician', frequencyValue: 1, frequencyUnit: 'years',
    estimatedHours: 3, complianceRequired: false,
  },
  {
    id: 'elec-003', category: 'Electrical', assetType: 'Electrical Panel', taskName: 'Ground Fault & AFCI Testing',
    trade: 'Electrician', frequencyValue: 1, frequencyUnit: 'years',
    estimatedHours: 2, complianceRequired: false,
  },
  {
    id: 'elec-004', category: 'Electrical', assetType: 'Emergency Lighting', taskName: 'Emergency Lighting 30-Second Test',
    trade: 'Facility Staff', frequencyValue: 1, frequencyUnit: 'months',
    estimatedHours: 1, complianceRequired: true, complianceStandard: 'NFPA 101',
  },
  {
    id: 'elec-005', category: 'Electrical', assetType: 'Emergency Lighting', taskName: 'Emergency Lighting 90-Minute Full Test',
    trade: 'Facility Staff', frequencyValue: 1, frequencyUnit: 'years',
    estimatedHours: 2, complianceRequired: true, complianceStandard: 'NFPA 101',
  },
  {
    id: 'elec-006', category: 'Electrical', assetType: 'Generator', taskName: 'Generator No-Load Run Test',
    trade: 'Generator Tech', frequencyValue: 1, frequencyUnit: 'months',
    estimatedHours: 1, complianceRequired: true, complianceStandard: 'NFPA 110',
  },
  {
    id: 'elec-007', category: 'Electrical', assetType: 'Generator', taskName: 'Generator Load Bank Test',
    trade: 'Generator Tech', frequencyValue: 1, frequencyUnit: 'years',
    estimatedHours: 4, complianceRequired: true, complianceStandard: 'NFPA 110',
  },
  {
    id: 'elec-008', category: 'Electrical', assetType: 'GFCI Outlet', taskName: 'GFCI Outlet Testing',
    trade: 'Facility Staff', frequencyValue: 1, frequencyUnit: 'months',
    estimatedHours: 1, complianceRequired: false,
  },
  {
    id: 'elec-009', category: 'Electrical', assetType: 'UPS', taskName: 'UPS Battery Inspection & Load Test',
    trade: 'Electrician', frequencyValue: 1, frequencyUnit: 'years',
    estimatedHours: 2, complianceRequired: false,
  },
  {
    id: 'elec-010', category: 'Electrical', assetType: 'Lighting', taskName: 'Lighting Fixture Cleaning & Lamp Replacement',
    trade: 'Facility Staff', frequencyValue: 1, frequencyUnit: 'years',
    estimatedHours: 4, complianceRequired: false,
  },

  // ─── Plumbing ─────────────────────────────────────────────────────────────
  {
    id: 'plmb-001', category: 'Plumbing', assetType: 'Backflow Preventer', taskName: 'Backflow Preventer Test & Certification',
    trade: 'Licensed Tester', frequencyValue: 1, frequencyUnit: 'years',
    estimatedHours: 2, complianceRequired: true, complianceStandard: 'AWWA / Local Code',
  },
  {
    id: 'plmb-002', category: 'Plumbing', assetType: 'Water Heater', taskName: 'Water Heater Flush & Anode Rod Inspection',
    trade: 'Plumber', frequencyValue: 1, frequencyUnit: 'years',
    estimatedHours: 2, complianceRequired: false,
  },
  {
    id: 'plmb-003', category: 'Plumbing', assetType: 'PRV', taskName: 'Pressure Reducing Valve Test',
    trade: 'Plumber', frequencyValue: 1, frequencyUnit: 'years',
    estimatedHours: 1, complianceRequired: false,
  },
  {
    id: 'plmb-004', category: 'Plumbing', assetType: 'Floor Drain', taskName: 'Floor Drain Trap Priming',
    trade: 'Facility Staff', frequencyValue: 1, frequencyUnit: 'months',
    estimatedHours: 0.5, complianceRequired: false,
  },
  {
    id: 'plmb-005', category: 'Plumbing', assetType: 'Water Treatment System', taskName: 'Water Softener & Treatment System Service',
    trade: 'Plumber', frequencyValue: 6, frequencyUnit: 'months',
    estimatedHours: 2, complianceRequired: false,
  },
  {
    id: 'plmb-006', category: 'Plumbing', assetType: 'Hose Bib', taskName: 'Hose Bib Winterization',
    trade: 'Facility Staff', frequencyValue: 1, frequencyUnit: 'years',
    estimatedHours: 1, complianceRequired: false,
  },

  // ─── Fire & Life Safety ───────────────────────────────────────────────────
  {
    id: 'fire-001', category: 'Fire & Life Safety', assetType: 'Fire Extinguisher', taskName: 'Fire Extinguisher Visual Inspection',
    trade: 'Facility Staff', frequencyValue: 1, frequencyUnit: 'months',
    estimatedHours: 0.5, complianceRequired: true, complianceStandard: 'NFPA 10',
  },
  {
    id: 'fire-002', category: 'Fire & Life Safety', assetType: 'Fire Extinguisher', taskName: 'Fire Extinguisher Annual Service',
    trade: 'Fire Protection Tech', frequencyValue: 1, frequencyUnit: 'years',
    estimatedHours: 2, complianceRequired: true, complianceStandard: 'NFPA 10',
  },
  {
    id: 'fire-003', category: 'Fire & Life Safety', assetType: 'Sprinkler System', taskName: 'Sprinkler System Quarterly Inspection',
    trade: 'Fire Protection Tech', frequencyValue: 3, frequencyUnit: 'months',
    estimatedHours: 3, complianceRequired: true, complianceStandard: 'NFPA 25',
  },
  {
    id: 'fire-004', category: 'Fire & Life Safety', assetType: 'Fire Alarm', taskName: 'Fire Alarm Panel & Detector Annual Test',
    trade: 'Fire Alarm Tech', frequencyValue: 1, frequencyUnit: 'years',
    estimatedHours: 4, complianceRequired: true, complianceStandard: 'NFPA 72',
  },
  {
    id: 'fire-005', category: 'Fire & Life Safety', assetType: 'Exit Sign', taskName: 'Exit Sign Visual Inspection',
    trade: 'Facility Staff', frequencyValue: 1, frequencyUnit: 'months',
    estimatedHours: 0.5, complianceRequired: true, complianceStandard: 'NFPA 101',
  },
  {
    id: 'fire-006', category: 'Fire & Life Safety', assetType: 'Kitchen Hood', taskName: 'Kitchen Hood Suppression System Inspection',
    trade: 'Fire Protection Tech', frequencyValue: 6, frequencyUnit: 'months',
    estimatedHours: 2, complianceRequired: true, complianceStandard: 'NFPA 96',
  },

  // ─── Building Envelope ────────────────────────────────────────────────────
  {
    id: 'bldg-001', category: 'Building Envelope', assetType: 'Roof', taskName: 'Roof Inspection',
    trade: 'Roofing Contractor', frequencyValue: 6, frequencyUnit: 'months',
    estimatedHours: 3, complianceRequired: false,
  },
  {
    id: 'bldg-002', category: 'Building Envelope', assetType: 'Exterior Lighting', taskName: 'Exterior Lighting Inspection',
    trade: 'Facility Staff', frequencyValue: 1, frequencyUnit: 'months',
    estimatedHours: 1, complianceRequired: false,
  },
  {
    id: 'bldg-003', category: 'Building Envelope', assetType: 'Exterior Envelope', taskName: 'Caulking & Sealant Condition Inspection',
    trade: 'Facility Staff', frequencyValue: 1, frequencyUnit: 'years',
    estimatedHours: 2, complianceRequired: false,
  },
  {
    id: 'bldg-004', category: 'Building Envelope', assetType: 'Windows & Doors', taskName: 'Window & Door Weatherstripping Inspection',
    trade: 'Facility Staff', frequencyValue: 1, frequencyUnit: 'years',
    estimatedHours: 2, complianceRequired: false,
  },
  {
    id: 'bldg-005', category: 'Building Envelope', assetType: 'Parking / Pavement', taskName: 'Parking Lot & Pavement Inspection',
    trade: 'Facility Staff', frequencyValue: 1, frequencyUnit: 'years',
    estimatedHours: 2, complianceRequired: false,
  },

  // ─── Controls / BAS ──────────────────────────────────────────────────────
  {
    id: 'bas-001', category: 'Controls / BAS', assetType: 'BAS / Controls System', taskName: 'BAS Point Verification & Calibration',
    trade: 'Controls Tech', frequencyValue: 1, frequencyUnit: 'years',
    estimatedHours: 8, complianceRequired: false,
  },
  {
    id: 'bas-002', category: 'Controls / BAS', assetType: 'BAS / Controls System', taskName: 'Sequence of Operations Review',
    trade: 'Controls Tech', frequencyValue: 1, frequencyUnit: 'years',
    estimatedHours: 4, complianceRequired: false,
  },
  {
    id: 'bas-003', category: 'Controls / BAS', assetType: 'BAS / Controls System', taskName: 'Software & Firmware Updates',
    trade: 'Controls Tech', frequencyValue: 1, frequencyUnit: 'years',
    estimatedHours: 4, complianceRequired: false,
  },

  // ─── Added for assessment seeding coverage (2026-07) ─────────────────────
  {
    id: 'hvac-101', category: 'HVAC', assetType: 'Pump', taskName: 'Pump Inspection & Lubrication',
    trade: 'HVAC Tech', frequencyValue: 3, frequencyUnit: 'months',
    estimatedHours: 1, complianceRequired: false,
  },
  {
    id: 'hvac-102', category: 'HVAC', assetType: 'Pump', taskName: 'Pump Seal & Coupling Inspection',
    trade: 'HVAC Tech', frequencyValue: 1, frequencyUnit: 'years',
    estimatedHours: 2, complianceRequired: false,
  },
  {
    id: 'hvac-103', category: 'HVAC', assetType: 'Heat Exchanger', taskName: 'Heat Exchanger Inspection & Cleaning',
    trade: 'HVAC Tech', frequencyValue: 1, frequencyUnit: 'years',
    estimatedHours: 4, complianceRequired: false,
  },
  {
    id: 'hvac-104', category: 'HVAC', assetType: 'Unit Heater / Terminal Heat', taskName: 'Terminal Heating Unit Seasonal Service',
    trade: 'HVAC Tech', frequencyValue: 1, frequencyUnit: 'years',
    estimatedHours: 1.5, complianceRequired: false,
  },
  {
    id: 'hvac-105', category: 'HVAC', assetType: 'Humidifier', taskName: 'Humidifier Cleaning & Cylinder Service',
    trade: 'HVAC Tech', frequencyValue: 6, frequencyUnit: 'months',
    estimatedHours: 2, complianceRequired: false,
  },
  {
    id: 'hvac-106', category: 'HVAC', assetType: 'Energy Recovery Unit', taskName: 'ERV Core & Filter Service',
    trade: 'HVAC Tech', frequencyValue: 6, frequencyUnit: 'months',
    estimatedHours: 2, complianceRequired: false,
  },
  {
    id: 'hvac-107', category: 'HVAC', assetType: 'Walk-In Refrigeration', taskName: 'Refrigeration Coil Cleaning & Door Gasket Check',
    trade: 'HVAC Tech', frequencyValue: 3, frequencyUnit: 'months',
    estimatedHours: 2, complianceRequired: false,
  },
  {
    id: 'fire-101', category: 'Fire & Life Safety', assetType: 'Fire / Smoke Damper', taskName: 'Fire & Smoke Damper Operational Test',
    trade: 'Fire Protection Tech', frequencyValue: 4, frequencyUnit: 'years',
    estimatedHours: 8, complianceRequired: true, complianceStandard: 'NFPA 80 / NFPA 105',
  },
  {
    id: 'elec-101', category: 'Electrical', assetType: 'Transformer', taskName: 'Transformer IR Scan & Cleaning',
    trade: 'Electrician', frequencyValue: 1, frequencyUnit: 'years',
    estimatedHours: 2, complianceRequired: false,
  },
  {
    id: 'elec-102', category: 'Electrical', assetType: 'Automatic Transfer Switch', taskName: 'Automatic Transfer Switch Test',
    trade: 'Electrician', frequencyValue: 1, frequencyUnit: 'months',
    estimatedHours: 1, complianceRequired: true, complianceStandard: 'NFPA 110',
  },
  {
    id: 'elec-103', category: 'Electrical', assetType: 'VFD', taskName: 'VFD Filter / Heatsink Cleaning & Terminal Check',
    trade: 'Electrician', frequencyValue: 1, frequencyUnit: 'years',
    estimatedHours: 1.5, complianceRequired: false,
  },
  {
    id: 'plmb-101', category: 'Plumbing', assetType: 'Sump / Sewage Pump', taskName: 'Sump & Sewage Pump Operational Test',
    trade: 'Plumber', frequencyValue: 3, frequencyUnit: 'months',
    estimatedHours: 1, complianceRequired: false,
  },
  {
    id: 'plmb-102', category: 'Plumbing', assetType: 'Grease Interceptor', taskName: 'Grease Interceptor Inspection / Pump-Out',
    trade: 'Plumber', frequencyValue: 3, frequencyUnit: 'months',
    estimatedHours: 2, complianceRequired: false,
  },
  {
    id: 'plmb-103', category: 'Plumbing', assetType: 'Plumbing Fixtures', taskName: 'Fixture & Flush Valve Inspection',
    trade: 'Plumber', frequencyValue: 6, frequencyUnit: 'months',
    estimatedHours: 2, complianceRequired: false,
  },
  {
    id: 'plmb-104', category: 'Plumbing', assetType: 'Emergency Eye Wash / Shower', taskName: 'Eye Wash / Emergency Shower Activation Test',
    trade: 'Facility Staff', frequencyValue: 1, frequencyUnit: 'weeks',
    estimatedHours: 0.25, complianceRequired: true, complianceStandard: 'ANSI Z358.1',
  },
];

// Default hourly labor rates by trade (can be overridden per org in future)
export const TRADE_LABOR_RATES: Record<string, number> = {
  'HVAC Tech': 95,
  'Boiler Tech': 105,
  'Controls Tech': 115,
  'Electrician': 110,
  'Generator Tech': 100,
  'Plumber': 100,
  'Licensed Tester': 95,
  'Water Treatment Tech': 90,
  'Fire Protection Tech': 95,
  'Fire Alarm Tech': 100,
  'Roofing Contractor': 90,
  'General Contractor': 85,
  'Landscape Contractor': 75,
  'Paving Contractor': 85,
  'Facility Staff': 45,
};

export const getTradeRate = (trade: string): number =>
  TRADE_LABOR_RATES[trade] ?? 85; // default $85/hr if trade not found

export const ASSET_TYPES = PM_TASK_LIBRARY.map(t => t.assetType)
  .filter((v, i, a) => a.indexOf(v) === i)
  .sort();
